import { render } from "./QuitFormDesignModal.vue?vue&type=template&id=9bcf57e8&scoped=true&ts=true"
import script from "./QuitFormDesignModal.vue?vue&type=script&lang=ts"
export * from "./QuitFormDesignModal.vue?vue&type=script&lang=ts"

import "./QuitFormDesignModal.vue?vue&type=style&index=0&id=9bcf57e8&lang=scss&scoped=true"

import exportComponent from "../../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-9bcf57e8"]])

export default __exports__